import { render, staticRenderFns } from "./TribunalsStatus.vue?vue&type=template&id=f95f5980"
import script from "./TribunalsStatus.vue?vue&type=script&lang=js"
export * from "./TribunalsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports